import { createUserClassifierRepoService } from '@gmini/common/lib/Services/UserClassifierRepoService'

export const userClassifierRepoService = createUserClassifierRepoService({
  name: 'userClassifierRepoService',
})
